import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useAppVersion } from '../hooks/use-app-version';
import { Button } from './ui/button';

async function hardRefresh() {
    // Drop any cached responses so the reload pulls the freshly deployed assets.
    try {
        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map((key) => caches.delete(key)));
        }
        if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map((reg) => reg.unregister()));
        }
    } catch {
        // Best effort — reload regardless. Vite's hashed filenames mean a normal
        // reload of index.html already fetches the new bundle.
    }
    window.location.reload();
}

export function UpdateBanner() {
    const { updateAvailable } = useAppVersion();
    const [refreshing, setRefreshing] = useState(false);

    if (!updateAvailable) return null;

    return (
        <div
            role="status"
            className="tailwind-scope tw-bg-secondary-foreground tw-text-primary-foreground tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-px-3 tw-py-2 tw-text-center tw-text-xs tw-font-medium sm:tw-flex-row sm:tw-gap-x-3 sm:tw-gap-y-1.5 sm:tw-px-4 sm:tw-text-sm"
        >
            <span className="tw-text-balance">
                A new version of the app is available. Refresh to get the latest
                updates.
            </span>
            <Button
                size="sm"
                variant="secondary"
                disabled={refreshing}
                onClick={() => {
                    setRefreshing(true);
                    void hardRefresh();
                }}
                className="tw-w-full sm:tw-w-auto"
            >
                <RefreshCw className={refreshing ? 'tw-animate-spin' : undefined} />
                {refreshing ? 'Refreshing…' : 'Refresh now'}
            </Button>
        </div>
    );
}
